import { axiosClient } from "../api-client";

export function CreateCollection({ config, body }) {
	const id = body._id;
	delete body._id;
	if (id) return axiosClient.patch("/v1/nftcollections/" + id, body, config);
	return axiosClient.post("/v1/nftcollections", body, config);
}

export function CreateNftTemplate({ config, body }) {
	const id = body._id;
	delete body._id;
	if (id) return axiosClient.patch("/v1/nfttemplates/" + id, body, config);
	return axiosClient.post("/v1/nfttemplates", body, config);
}

export function UpdatHideShowTemplate({ config, body }) {
	const id = body._id;
	delete body._id;

	return axiosClient.patch(`/v1/nfttemplates/${id}/islocked`, body, config);
}

export function UpdateNftTemplate({ config, body }) {
	const id = body._id;
	delete body._id;
	if (id) return axiosClient.patch("/v1/nfttemplates/" + id, body, config);
	else return CreateNftTemplate({ config, body });
}

export function UpdateNftTemplateBulk({ body, config }) {
	const res = body.map((e) => UpdateNftTemplate({ config, body: e }));
	return Promise.all(res)
		.then((e) => {
			return e.map((e) => e._id);
		})
		.catch((err) => Promise.reject(err));
}

export function CreateNftTemplateBulk({ body, config }) {
	const res = body.map((e) => CreateNftTemplate({ config, body: e }));
	return Promise.all(res)
		.then((e) => {
			return e.map((e) => e._id);
		})
		.catch((err) => Promise.reject(err));
}

export function UpdateCollection({ config, body }) {
	const id = body._id;
	delete body._id;
	return axiosClient.patch("/v1/nftcollections/" + id, body, config);
}

export function AddRemoveFromCollection({ config, body }) {
	return axiosClient.patch("/v1/nftcollections/addremove", body, config);
}

export function GetCollection({ config, body }) {
	return axiosClient.get("/v1/nftcollections/" + body, {
		params: {
			fromAdmin: true,
			...config.params,
		},
		...config,
	});
}

export function GetCollectionsSimple({ config }) {
	return axiosClient.get("/v1/nftcollections/list/simple?status=SCHEDULE", {
		...config,
	});
}

export function GetCollections({ config, body }) {
	return axiosClient.get("/v1/nftcollections/list", {
		...config,
		params: {
			...config.params,
			...body,
		},
	});
}

export function GetBidList({ config, body }) {
	return axiosClient.get("/v1/auctions/bid/list", {
		...config,
		params: {
			...config.params,
			...body,
		},
	});
}

export function GetBidderList({ config, body }) {
	return axiosClient.get("/v1/auctions/bidder/list", {
		...config,
		params: {
			...config.params,
			...body,
		},
	});
}

export function GetEvents({ config, body }) {
	return axiosClient.get("/v1/nftevents", {
		...config,
		params: {
			...config.params,
			...body,
		},
	});
}

export function DeleteCollection({ body, config }) {
	return axiosClient.delete("/v1/nftcollections/" + body, config);
}

export function DeleteProduct({ body, config }) {
	return axiosClient.delete("/v1/nfttemplates/" + body, config);
}

export function MintProduct({ body, config }) {
	return axiosClient.post(`/v1/nfttemplates/${body}/mint`, {}, config);
}

export function GetProduct({ body, config }) {
	return axiosClient.get("/v1/nfttemplates/" + body, config);
}

export function GetPopular({ body, config }) {
	return axiosClient.get("/v1/nfttemplates/hottest_and_category/templates", {
		...config,
		params: {
			fromAdmin: true,
			type: "HOTTEST",
			skip: 0,
			limit: body,
			...config.params,
		},
	});
}

export function GetNFTs({ body, config }) {
	return axiosClient.get("/v1/nfts", {
		...config,
		params: {
			...config.params,
			...body,
		},
	});
}

export function GetNFTsBrand({ body, config }) {
	return axiosClient.get("/v1/nfts/brand", {
		...config,
		params: {
			...config.params,
			...body,
		},
	});
}

export function GetNFTsAdmin({ body, config }) {
	return axiosClient.get("/v1/admin/nfts/list", {
		...config,
		params: {
			...config.params,
			...body,
		},
	});
}

export function GetWalletNFTsAdmin({ body, config }) {
	return axiosClient.get("/v1/admin/nfts/wallet-list", {
		...config,
		params: {
			...config.params,
			...body,
		},
	});
}

export function GetNFT({ body, config }) {
	return axiosClient.get("/v1/nfts/" + body, config);
}

export function GetActivity({ body, config }) {
	return axiosClient.get("/v1/activity/nft_activity/" + body._id, {
		...config,
		params: {
			...config.params,
			market: body.market,
		},
	});
}

export function GetActivityAll({ body, config }) {
	return axiosClient.get("/v1/activity/nft_activity", {
		...config,
		params: {
			...config.params,
			market: body.market,
		},
	});
}

export function GetActivityCount({ body, config }) {
	return axiosClient.get("/v1/activity/nft_activityCount", {
		...config,
		params: {
			...config.params,
			range: body.range,
			market: body.market,
		},
	});
}
